import React from "react";
import SapExportsListComponent from "../components/sapExports/SapExportsListComponent";

export default function SapExports() {
  return (
    <>
      <SapExportsListComponent />
    </>
  );
}
